import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, vShow as _vShow } from "vue"
import _imports_0 from '../assets//logo_wTVision_small.png'
import _imports_1 from '../assets/admin.png'
import _imports_2 from '../assets/settings.png'
import _imports_3 from '../assets/options.png'
import _imports_4 from '../assets/logout.png'
import _imports_5 from '../assets/cloud_save.png'
import _imports_6 from '../assets/download.png'
import _imports_7 from '../assets/rules.png'


const _hoisted_1 = { class: "editor-main" }
const _hoisted_2 = { class: "menubar-area" }
const _hoisted_3 = { class: "menubar-items" }
const _hoisted_4 = { class: "menubar-user" }
const _hoisted_5 = { class: "menubar-user" }
const _hoisted_6 = {
  class: "menubar-presence",
  "aria-label": "Users online in project"
}
const _hoisted_7 = ["title", "onClick"]
const _hoisted_8 = { class: "editor-area" }
const _hoisted_9 = { class: "left-side-bar" }
const _hoisted_10 = { class: "middle-side" }
const _hoisted_11 = {
  key: 0,
  class: "exporter"
}
const _hoisted_12 = {
  key: 1,
  class: "loader"
}
const _hoisted_13 = {
  key: 2,
  class: "downloader"
}
const _hoisted_14 = {
  key: 3,
  class: "export-progress"
}
const _hoisted_15 = { class: "export-progress-label" }
const _hoisted_16 = { class: "export-progress-bar" }
const _hoisted_17 = {
  key: 4,
  class: "loader"
}
const _hoisted_18 = {
  key: 5,
  class: "downloader"
}
const _hoisted_19 = {
  key: 6,
  class: "validated-overlay"
}
const _hoisted_20 = {
  key: 7,
  class: "validated-overlay"
}
const _hoisted_21 = {
  class: "validated-badge",
  style: {"background":"#7f1d1d"}
}
const _hoisted_22 = {
  key: 0,
  class: "validated-badge",
  style: {"background":"#1f2937"}
}
const _hoisted_23 = { class: "right-side-bar" }
const _hoisted_24 = { class: "labels-container" }
const _hoisted_25 = {
  key: 0,
  class: "options-menu"
}
const _hoisted_26 = {
  key: 1,
  class: "settings-menu"
}
const _hoisted_27 = { class: "rules-global-options" }
const _hoisted_28 = { class: "rule-row" }
const _hoisted_29 = { class: "switch" }
const _hoisted_30 = { class: "rule-row" }
const _hoisted_31 = { class: "rule-row" }
const _hoisted_32 = { class: "inline-inputs" }
const _hoisted_33 = { class: "rule-row" }
const _hoisted_34 = { class: "rule-color-picker" }
const _hoisted_35 = { class: "rule-header" }
const _hoisted_36 = { class: "rule-list" }
const _hoisted_37 = { class: "rule-item" }
const _hoisted_38 = { class: "rule-label" }
const _hoisted_39 = { class: "rule-color" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "shortcut-kbd" }
const _hoisted_43 = { class: "shortcut-desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Thumbnail = _resolveComponent("Thumbnail")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ImageCanvas = _resolveComponent("ImageCanvas")!
  const _component_Labels = _resolveComponent("Labels")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "menubar-logo",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
      }, _cache[15] || (_cache[15] = [
        _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1),
        _createElementVNode("span", null, "ision", -1)
      ])),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: "",
            title: "Administrator Dashboard",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.navToAdmin && _ctx.navToAdmin(...args)))
          })
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["menubar-options", {'menubar-options-disable':_ctx.loading}]),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showOptions && _ctx.showOptions(...args)))
        }, _cache[16] || (_cache[16] = [
          _createElementVNode("img", {
            src: _imports_2,
            title: "Options"
          }, null, -1)
        ]), 2),
        _createElementVNode("div", {
          class: _normalizeClass(["menubar-settings", {'menubar-settings-disable':_ctx.loading}]),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showSettings && _ctx.showSettings(...args)))
        }, _cache[17] || (_cache[17] = [
          _createElementVNode("img", {
            src: _imports_3,
            title: "Settings"
          }, null, -1)
        ]), 2),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: _imports_4,
            alt: "",
            title: "Logout",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.navToLogout && _ctx.navToLogout(...args)))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentUsers, (u) => {
          return (_openBlock(), _createElementBlock("div", {
            key: u.key,
            class: "presence-dot",
            title: u.email || 'unknown',
            style: _normalizeStyle(_ctx.dotStyle(u)),
            onClick: ($event: any) => (_ctx.onPresenceBadgeClick(u))
          }, _toDisplayString((u.email || '?').charAt(0).toUpperCase()), 13, _hoisted_7))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_Thumbnail, {
          ref: "thumbsRef",
          projectId: _ctx.currentProject?.id ?? null,
          selectedId: _ctx.selectedThumbnail?.id ?? null,
          onOnThumbnailSelected: _ctx.onThumbnailSelected,
          onRequestDelete: _ctx.onThumbRequestDelete,
          onRequestUpload: _ctx.onThumbRequestUpload
        }, null, 8, ["projectId", "selectedId", "onOnThumbnailSelected", "onRequestDelete", "onRequestUpload"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.exporting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Please Wait"))
          : _createCommentVNode("", true),
        (_ctx.exporting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Export ng"))
          : _createCommentVNode("", true),
        (_ctx.exporting)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.exporting)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.exportLabel), 1),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", {
                  class: "export-progress-fill",
                  style: _normalizeStyle({ width: _ctx.exportPercent + '%' })
                }, null, 4)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "Load ng"))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18))
          : _createCommentVNode("", true),
        (_ctx.selectedThumbnail?.is_validated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "validated-badge" }, "Read-only: Validated Image", -1)),
              (_ctx.canRevertValidation)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    onClick: _ctx.unvalidateSelected,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("Revert Validation")
                    ])),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.selectedThumbnail?.is_invalidated)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.username), 1),
              (_ctx.selectedThumbnail?.invalidate_notes)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.selectedThumbnail.invalidate_notes), 1))
                : _createCommentVNode("", true),
              (_ctx.canCorrect)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    onClick: _ctx.markCorrected,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[20] || (_cache[20] = [
                      _createTextVNode("Corrected")
                    ])),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ImageCanvas, {
          ref: "canvasRef",
          image: _ctx.selectedThumbnail,
          highLightedLine: _ctx.highlightedLine,
          readOnly: !!_ctx.selectedThumbnail?.is_validated,
          onOnNewLine: _ctx.onNewLine,
          onOnDeleteLine: _ctx.onDeleteLine
        }, null, 8, ["image", "highLightedLine", "readOnly", "onOnNewLine", "onOnDeleteLine"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          (_ctx.selectedThumbnail)
            ? (_openBlock(), _createBlock(_component_Labels, {
                key: 0,
                ref: "labelsRef",
                image: _ctx.selectedThumbnail,
                onNewLine: _ctx.newLine,
                onDeleteLine: _ctx.oldLine,
                readOnly: !!_ctx.selectedThumbnail?.is_validated,
                mode: "editor",
                onOnLabelFocus: _ctx.onLabelFocus,
                onOnLabelChanged: _ctx.onLabelChanged
              }, null, 8, ["image", "onNewLine", "onDeleteLine", "readOnly", "onOnLabelFocus", "onOnLabelChanged"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.optionsMenuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[5] || (_cache[5] = () => {}),
              class: "options"
            }, _cache[21] || (_cache[21] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "Save To Cloud",
                title: "Save"
              }, null, -1),
              _createElementVNode("span", null, "Save", -1)
            ])),
            _createElementVNode("li", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.createAndDownloadZipCSV && _ctx.createAndDownloadZipCSV(...args))),
              class: "options"
            }, _cache[22] || (_cache[22] = [
              _createElementVNode("img", {
                src: _imports_6,
                alt: "Export",
                title: "Save"
              }, null, -1),
              _createElementVNode("span", null, "Export Masks", -1)
            ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settingsMenuVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", {
              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.openRules && _ctx.openRules(...args))),
              class: "settings"
            }, _cache[23] || (_cache[23] = [
              _createElementVNode("img", {
                src: _imports_7,
                alt: "Rules",
                title: "Export Rules"
              }, null, -1),
              _createElementVNode("span", null, "Rules", -1)
            ]))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.isOpenRules,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isOpenRules) = $event)),
      class: "modal"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _cache[25] || (_cache[25] = _createElementVNode("label", { class: "rule-text" }, "Export Original Images", -1)),
            _createElementVNode("label", _hoisted_29, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rules.exportImages) = $event))
              }, null, 512), [
                [_vModelCheckbox, _ctx.rules.exportImages]
              ]),
              _cache[24] || (_cache[24] = _createElementVNode("span", { class: "slider round" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[26] || (_cache[26] = _createElementVNode("label", { class: "rule-text" }, "Line Size (px)", -1)),
            _withDirectives(_createElementVNode("input", {
              class: "color-input center-input",
              type: "text",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.rules.lineSize) = $event)),
              placeholder: "Line size"
            }, null, 512), [
              [_vModelText, _ctx.rules.lineSize]
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _cache[28] || (_cache[28] = _createElementVNode("label", { class: "rule-text" }, "Export Size", -1)),
            _createElementVNode("div", _hoisted_32, [
              _withDirectives(_createElementVNode("input", {
                class: "color-input center-input",
                type: "text",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.rules.exportWidth) = $event)),
                placeholder: "width"
              }, null, 512), [
                [_vModelText, _ctx.rules.exportWidth]
              ]),
              _cache[27] || (_cache[27] = _createElementVNode("span", { class: "multiplier" }, "x", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "color-input center-input",
                type: "text",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.rules.exportHeight) = $event)),
                placeholder: "height"
              }, null, 512), [
                [_vModelText, _ctx.rules.exportHeight]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _cache[29] || (_cache[29] = _createElementVNode("label", { class: "rule-text" }, "Background Color", -1)),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("input", {
                class: "color-picker",
                type: "color",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.rules.backgroundColor) = $event))
              }, null, 512), [
                [_vModelText, _ctx.rules.backgroundColor]
              ]),
              _withDirectives(_createElementVNode("input", {
                class: "color-input center-input",
                type: "text",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rules.backgroundColor) = $event)),
                placeholder: "eg.: black"
              }, null, 512), [
                [_vModelText, _ctx.rules.backgroundColor]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "rule-header-text" }, "Label", -1)),
          _createVNode(_component_font_awesome_icon, {
            class: "rule-fill-colors-icon",
            icon: ['fas', 'fill-drip'],
            title: "Increment Colors",
            onClick: _ctx.autoIncrementColors
          }, null, 8, ["onClick"]),
          _createVNode(_component_font_awesome_icon, {
            class: "rule-save-icon",
            icon: ['fas', 'save'],
            title: "Save Rules",
            onClick: _ctx.saveRules
          }, null, 8, ["onClick"])
        ]),
        _createElementVNode("ul", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules.rules, (rule) => {
            return (_openBlock(), _createElementBlock("li", {
              key: rule.label
            }, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("span", _hoisted_38, _toDisplayString(rule.label), 1),
                _createElementVNode("div", _hoisted_39, [
                  _withDirectives(_createElementVNode("input", {
                    class: "color-picker",
                    type: "color",
                    "onUpdate:modelValue": ($event: any) => ((rule.color) = $event)
                  }, null, 8, _hoisted_40), [
                    [_vModelText, rule.color]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    class: "color-input",
                    type: "text",
                    "onUpdate:modelValue": ($event: any) => ((rule.color) = $event)
                  }, null, 8, _hoisted_41), [
                    [_vModelText, rule.color]
                  ]),
                  _createVNode(_component_font_awesome_icon, {
                    class: "color-delete",
                    icon: ['fas', 'trash-can'],
                    onClick: ($event: any) => (_ctx.deleteRule(rule))
                  }, null, 8, ["onClick"])
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["shortcut-toast", { 'is-hiding': _ctx.isHiding }]),
      role: "status",
      "aria-live": "polite"
    }, [
      _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.shortcutToast.combo), 1),
      _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.shortcutToast.label), 1)
    ], 2), [
      [_vShow, _ctx.shortcutToast.show || _ctx.isHiding]
    ])
  ]))
}